function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';

var Lines = function (_Component) {
    _inherits(Lines, _Component);

    function Lines() {
        var _temp, _this, _ret;

        _classCallCheck(this, Lines);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.renderLine = function (line) {
            var lineGenerator = _this.props.lineGenerator;
            var id = line.id,
                data = line.data,
                color = line.color;


            var className = "line  line--" + id;

            return React.createElement("path", {
                key: id,
                d: lineGenerator(data.map(function (d) {
                    return {
                        x: d.position.x,
                        y: d.position.y
                    };
                })),
                stroke: color,
                fill: "none",
                className: className
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    Lines.prototype.render = function render() {
        var series = this.props.series;


        return React.createElement(
            "g",
            { className: "lines" },
            series.map(this.renderLine)
        );
    };

    return Lines;
}(Component);

export default Lines;